import { SearchReqResponse } from '../services/search-service';

export class SynonymResult {
  public synonym: string;
  public resp: SearchReqResponse;
}
